import { RadioOption } from "components/RadioGroup/types";
import { routeConstants } from "constants/routeConstants";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "slice";
import { updateNewJobData, useGetJobPurposesQuery } from "slice/jobs";
import { useEditJob } from "../useEditJob";

export const useJobPurpose = () => {
    const { data, isFetching, isError } = useGetJobPurposesQuery({});
    const [options, setOptions] = useState<RadioOption[]>([]);

    const { newJobData } = useAppSelector((state) => state.jobs);

    const isEdit = newJobData?.isEdit;
    const [selectedOption, setSelectedOption] = useState("");

    const { id: job_id } = useParams();

    useEditJob();
    const dispatch = useDispatch();
    const navigateTo = useNavigate();

    const handleJobPurposeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSelectedOption(e.target.value);
    };

    const handleBack = () => {
        if (isEdit) {
            navigateTo(
                routeConstants.jobs.editAJob.root +
                    `${newJobData?.id}/` +
                    routeConstants.jobs.editAJob.category
            );
        } else navigateTo(routeConstants.jobs.postAJob.root);
    };

    const handleNext = () => {
        dispatch(
            updateNewJobData({
                ...newJobData,
                job_purpose: data?.job_purposes?.find(
                    (purpose) => purpose.id === Number(selectedOption)
                ),
            })
        );
        if (isEdit) {
            navigateTo(
                routeConstants.jobs.editAJob.root +
                    `${newJobData?.id}/` +
                    routeConstants.jobs.editAJob.location
            );
        } else
            navigateTo(
                routeConstants.jobs.postAJob.root +
                    routeConstants.jobs.postAJob.location
            );
    };

    useEffect(() => {
        if (data) {
            setOptions(
                data.job_purposes?.map((purpose) => ({
                    label: purpose.name,
                    value: String(purpose.id),
                }))
            );
            if (newJobData?.job_purpose) {
                setSelectedOption(newJobData.job_purpose?.id.toString());
            } else setSelectedOption(data.job_purposes[0].id.toString());
        }
    }, [data, newJobData]);

    useEffect(() => {
        if (!newJobData?.job_category) {
            if (job_id) {
                navigateTo(
                    routeConstants.jobs.editAJob.root +
                        routeConstants.jobs.postAJob.category +
                        job_id
                );
            } else
                navigateTo(
                    routeConstants.jobs.postAJob.root +
                        routeConstants.jobs.postAJob.category
                );
        }
    }, [job_id, navigateTo, newJobData]);

    return {
        isFetching,
        selectedOption,
        handleJobPurposeChange,
        handleBack,
        handleNext,
        isError,
        options,
    };
};
